module.exports = __webpack_public_path__ + "img/Perks-30.8158cc37.png";